<template>
		<div id="pageRoot">

			<p id="text01">
Y así fue como Venancio aprendió a volar. Al principio a todo el mundo le pareció lindo eso de que hubiese un perro volando por el barrio. Pero enseguida empezaron las quejas. Porque la verdad es que Venancio no volaba como una mariposa. Ni como un pajarito.<br><br>
Más bien volaba como un almohadón desesperado.<br><br>
Para empezar, era gordo.<br><br>
Para seguir, volaba muy rápido.<br><br>
Y para terminar, le gustaba volar bajito.<br><br>
Como era gordo y volaba tan rápido y tan bajito, provocaba muchísimos accidentes. Un día le arrancó el casco a un policía al cruzar la avenida y don Fito tuvo que pagar una multa. Un sábado a la noche se chocó con la cabeza de Martinita Pérez, justo cuando Martinita Pérez salía de su casa vestida de novia, y toda llena de flores, para casarse con Tito Nicoletti.<br><br>
Otro día se metió sin querer por la ventana del profesor Gutiérrez,<br>
que estaba abierta, y se cayó encima del pastel de papas.
			</p>

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<span class="footer-page footer-listen"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>
#text01
{
position: absolute;
left: 4.98%;
right: 4.98%;
top: 7.68%;
bottom: 13.28%;
margin: 0px;
z-index: 3;

font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 22px;
line-height: 29px;

color: #000000;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p53-57/V16.mp4"]
    }
  }
}
</script>